import type { ModuleNav } from '@saas/ui';

export const SAFETY_ADMIN_ROLES = ['owner', 'admin'];

/** safety のメニュー。回答者（全員）は「連絡先の設定」だけ、発報側は権限で絞る */
export const safetyNav: ModuleNav = {
  module: 'safety',
  items: [
    { label: '安否確認', to: '/safety', icon: 'shield', end: true, permission: ['safety.event.read', 'safety.event.manage'], description: '発報の状況・回答率' },
    { label: '安否の連絡先', to: '/safety/me', icon: 'person', permission: 'safety.contact.manage_own', description: 'メール・SMS・所在地の登録' },
  ],
  admin: [
    { label: '安否確認の発報', to: '/safety/fire', icon: 'send', permission: 'safety.event.manage', description: '訓練 / 本番の一斉配信' },
    { label: '発報の下書き', to: '/safety/drafts', icon: 'inbox', permission: ['safety.event.read', 'safety.event.manage'], description: '気象・津波（自動発報しない）' },
    { label: '発報条件', to: '/safety/triggers', icon: 'bolt', permission: 'safety.trigger.manage', description: '震度・地域と気象庁 XML の突合' },
    { label: '配信テンプレート', to: '/safety/templates', icon: 'description', permission: 'safety.template.manage', description: '件名・本文・設問' },
    { label: '訓練レポート', to: '/safety/reports', icon: 'bar_chart', permission: ['safety.report.read', 'safety.event.manage'], description: '到達率・回答率・CSV' },
    { label: '安否確認の設定', to: '/safety/settings', icon: 'settings', permission: 'safety.event.manage', description: '回答の保存期間・訓練後アンケート' },
  ],
};
